import React from 'react';

import { Button } from '@schoolinks/ui-components';
import * as Sentry from '@sentry/react';
import { decode } from 'jsonwebtoken';
import { noop } from 'lodash';
import { shape, func } from 'prop-types';

import Paper from '@mui/material/Paper';

import { JWT } from 'constants/system';

import { getCookie } from 'utils/cookies';

import s from './ErrorBox.css';

// eslint-disable-next-line no-unused-vars
const ErrorBox = ({ error, componentStack, resetError }) => {
  Sentry.withScope(scope => {
    const token = getCookie(JWT);

    // scope.setTag('version', VERSION);
    scope.setUser({
      type: 'guest',
      ...((token && decode(token)) || {}),
    });
    Sentry.captureException(error);
  });

  const handleResetError = () => {
    resetError();
  };

  // Using useTranslation hook prevented this component from rendering. Needs more investigation but will use plain strings for now.
  return (
    <div className={s.errorPage}>
      <Paper className={s.paper}>
        <div className={s.secondaryText}>
          Uh Oh! There was an Issue Processing Your Request.
        </div>
        <div className={s.primaryText}>We&apos;re looking into it!</div>
        <Button
          href="/"
          onClick={handleResetError}
          className={s.backToDashboard}
          color="secondary"
          variant="outlined"
          label="Return to Dashboard"
        />
      </Paper>
      <div className={s.errorId}>Error code: {error?.toString()}</div>
    </div>
  );
};

ErrorBox.propTypes = {
  error: shape({}).isRequired,
  componentStack: shape({}).isRequired,
  resetError: func,
};

ErrorBox.defaultProps = {
  resetError: noop,
};

export default ErrorBox;
